export enum Mode {
  EXCLUDING,
  INCLUDING
}

export enum Level {
  DEBUG,
  WARN,
  ERROR
}

const noop = () => {
  return;
};

export interface LoggerOptions {
  writer: any;
  mode: Mode;
  level: Level;
  prefix?: false;
  excludes: string[];
  includes: string[];
}

export class LoggerFactoryClass {
  public options: LoggerOptions;

  public constructor(options: LoggerOptions) {
    this.options = options;
  }

  public create(name: string, options?: LoggerOptions) {
    return new Logger(name, Object.assign({}, this.options, options || {}));
  }
}

export class Logger {
  public writer: any;
  public mode: Mode;
  public excludes: string[];
  public includes: string[];
  public name: string;
  public level: Level;
  public prefix: boolean;

  private formatter: Intl.DateTimeFormat;

  constructor(name: string, options: LoggerOptions) {
    this.writer = options.writer;
    this.mode = options.mode;
    this.excludes = options.excludes;
    this.includes = options.includes;
    this.level = options.level;
    this.name = name;
    this.prefix = options.prefix !== false;
    this.blankIfExcluded();
    this.formatter = new Intl.DateTimeFormat(navigator.languages[0], {
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    });
  }

  public blankIfExcluded() {
    if (this.mode === Mode.EXCLUDING) {
      if (this.excludes.indexOf(this.name) !== -1) {
        this.log = noop;
      }
    } else if (this.includes.indexOf(this.name) === -1) {
      this.log = noop;
    }

    switch (this.level) {
      case Level.ERROR:
        this.warn = noop;
      case Level.WARN:
        this.debug = noop;
    }
  }

  public debug(...args: any[]) {
    args.unshift("debug");
    this.log.apply(this, args as [string, ...any[]]);
  }

  public warn(...args: any[]) {
    args.unshift("warn");
    this.log.apply(this, args as [string, ...any[]]);
  }

  public error(...args: any[]) {
    args.unshift("error");
    this.log.apply(this, args as [string, ...any[]]);
  }

  private log(level: string, ...args: any[]) {
    const date = new Date();
    const time = this.formatter.format(date);
    const prefix = `%c ${time}.${date.getMilliseconds()} ${this.name}:`;
    const style = "color: green;";

    if (this.prefix) {
      args.unshift(prefix, style);
    }

    this.writer[level].apply(this.writer, args);
  }
}

export const LoggerFactory = new LoggerFactoryClass({
  writer: console,
  level: Level.DEBUG,
  mode: Mode.EXCLUDING,
  excludes: [],
  includes: []
});
